import userManagement from './moduleUserManagement'
export default userManagement
